require('@fastnorth/public-facing/dist/js/public-facing');
require('./setup-ajax');
require('./contact-modal');
require('./charity-widget');
require('./email-share');

window.Cookies = require('js-cookie');
